import _ from 'lodash';

import { EditedPart } from './CicEditHistoryList.constants';

const getEditedPart = ({ isReasonChanged, isCommentChanged }) => {
  if (isReasonChanged && isCommentChanged) {
    return EditedPart.REASON_AND_COMMENT;
  }

  return isReasonChanged ? EditedPart.REASON : EditedPart.COMMENT;
};

const toRevisionEntry = (revision, index) => {
  const isReasonChanged = revision.previousCicReasonId !== revision.newCicReasonId;
  const isCommentChanged = (revision.previousComment ?? '') !== (revision.newComment ?? '');

  return {
    key: `revision-${index}`,
    isOriginal: false,
    authorName: revision.changedByName,
    date: revision.changedDate,
    action: `changed ${getEditedPart({ isReasonChanged, isCommentChanged })}`,
    isReasonChanged,
    isCommentChanged,
    previousReasonName: revision.previousReasonName,
    newReasonName: revision.newReasonName,
    previousComment: revision.previousComment,
    newComment: revision.newComment,
  };
};

/** Newest edit first, ending with the original entry; the first revision holds the original reason. */
export const buildEditHistoryEntries = ({
  revisions,
  reasonName,
  comment,
  changedByName,
  changedDate,
}) => {
  const firstRevision = _.first(revisions);

  const original = {
    key: 'original',
    isOriginal: true,
    authorName: changedByName,
    date: changedDate,
    reasonName: firstRevision ? firstRevision.previousReasonName : reasonName,
    comment: firstRevision ? firstRevision.previousComment : comment,
  };

  return [...(revisions ?? []).map(toRevisionEntry).reverse(), original];
};
